import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './i18n';
import { VercelAnalyticsManager } from './components/VercelAnalyticsManager';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Language is a URL concern, not a client-side toggle: "/en/..." is the
// English site, everything else is Norwegian. Search engines only ever
// see one deterministic version per URL this way (no cookie/header
// guessing - see i18n.ts and seo/pageMeta.ts for the matching server-side
// logic), which is what lets Google index and rank the English pages for
// English queries. The basename below makes every <Link>/navigate() in
// the app automatically stay under the current language's prefix.
const basename = /^\/en(\/|$)/.test(window.location.pathname) ? '/en' : '';

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
      <VercelAnalyticsManager />
    </BrowserRouter>
  </React.StrictMode>
);
